export function ErrorBanner({ message }: { message: string }) {
  if (!message) return null;
  return (
    <div className="px-4 py-3 bg-red-50 border-l-4 border-[var(--color-accent)] text-[var(--color-accent)] mb-4">
      {message}
    </div>
  );
}
